module.exports = __webpack_public_path__ + "img/FigmaDDSSlicePNGc9197906aeff173ae861090ce8f65f5a.c9197906.png";